import { useEffect, useState } from 'react';
import Page from '../../../components/page/Page';
import Header from '../../../components/company/Header';
import { useCompanyCore } from '../../../../core/modules/company';
import useThemeMediaQuery from '../../../../core/hooks/useThemeMediaQuery';
import { useParams } from 'react-router-dom';
import { Tab, Tabs } from '@mui/material';
import BasicInfoTab from '../../../components/company/tabs/BasicInfoTab';
import { useMeCore } from '../../../../core/modules/me';
import { useNavigationCore } from '../../../../core/router/navigation';
import UserDialog from '../../../components/company/UserDialog';
import { useUserCore } from '../../../../core/modules/user';
import { UserType } from '../../../../core/enums/userType.enum';
import CompanyDialog from '../../../components/companies/CompanyDialog';
import UsersTab from '../../../components/company/tabs/UsersTab';
import MetricsTab from '../../../components/company/tabs/MetricsTab';
import MetricDialog from '../../../components/company/MetricDialog';
import { useMetricsCore } from '../../../../core/modules/metrics';
import StoresTab from '../../../components/company/tabs/StoresTab';
import StoreDialog from '../../../components/company/StoreDialog';
import GraphicsTab from '../../../components/company/tabs/GraphicsTab';
import GraphDialog from '../../../components/company/GraphDialog';
import IntegrationTab from '../../../components/company/tabs/IntegrationTab';
import AiChatTab from '../../../components/company/tabs/AiChatTab';
import InventoryCountTab from '../../../components/company/tabs/InventoryCountTab';
import StockComparisonTab from '../../../components/company/tabs/StockComparisonTab';

const Company = () => {
  const { id } = useParams();
  const { user } = useMeCore();
  const { clearUser, getUsers } = useUserCore();
  const { getMetricTypes, getGraphTypes } = useMetricsCore();
  const { getCompany, getUsers: getCompanyUsers, getStores } = useCompanyCore();
  const { goToWelcome } = useNavigationCore();

  const [tabValue, setTabValue] = useState(0);

  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));

  useEffect(() => {
    if (!user?.is_superuser) {
      goToWelcome();
    }
  }, [user, goToWelcome]);

  useEffect(() => {
    clearUser();

    if (id) {
      getCompanyUsers(id);
      getStores(id);
      getMetricTypes(id);
      getGraphTypes(id);
      getUsers({ role: UserType.user });
      getCompany(id);
    }
  }, [id, getCompany, clearUser, getUsers, getCompanyUsers, getMetricTypes, getStores, getGraphTypes]);

  return (
    <>
      <Page
        header={<Header />}
        content={
          <div className="w-full h-full bg-white">
            <Tabs
              value={tabValue}
              onChange={(_e, v) => setTabValue(v)}
              indicatorColor="secondary"
              textColor="secondary"
              variant="scrollable"
              scrollButtons="auto"
              classes={{ root: 'w-full border-b-1' }}
            >
              <Tab className="h-64" label="Información" />
              <Tab className="h-64" label="Usuarios" />
              <Tab className="h-64" label="Métricas" />
              {/* <Tab className="h-64" label="Gráficos" /> */}
              <Tab className="h-64" label="Almacenes" />
              <Tab className="h-64" label="Integraciones" />
              <Tab className="h-64" label="Chatbot IA" />
              <Tab className="h-64" label="Toma de Inventario" />
              <Tab className="h-64" label="Stock Comparison" />
            </Tabs>
            <div className="p-16 sm:p-24 bg-white">
              <div className={tabValue !== 0 ? 'hidden' : ''}>
                <BasicInfoTab />
              </div>
              
              <div className={tabValue !== 1 ? 'hidden' : ''}>
                <UsersTab />
              </div>

              <div className={tabValue !== 2 ? 'hidden' : ''}>
                <MetricsTab />
              </div>
              {
                /**
                <div className={tabValue !== 3 ? 'hidden' : ''}>
                  <GraphicsTab />
                </div>
                 */
              }
              <div className={tabValue !== 3 ? 'hidden' : ''}>
                <StoresTab />
              </div>
              <div className={tabValue !== 4 ? 'hidden' : ''}>
                <IntegrationTab/>
              </div>
              <div className={tabValue !== 5 ? 'hidden' : ''}>
                <AiChatTab/>
              </div>
              <div className={tabValue !== 6 ? 'hidden' : ''}>
                <InventoryCountTab/>
              </div>
              <div className={tabValue !== 7 ? 'hidden' : ''}>
                <StockComparisonTab/>
              </div>
            </div>
          </div>
        }
        scroll={isMobile ? 'normal' : 'content'}
      />
      <CompanyDialog />
      <MetricDialog />
      <GraphDialog />
      <StoreDialog />
    </>
  );
};

export default Company;
